// extracted by mini-css-extract-plugin
export default {"answerInfoRow":"mnjcuYsNI3SOaXbxXdCQ","infoTitle":"x4ErK0ZMaXIneSL9g73t"};